import { render, staticRenderFns } from "./conti-constani.vue?vue&type=template&id=50f35a4d&scoped=true"
import script from "./conti-constani.vue?vue&type=script&lang=js"
export * from "./conti-constani.vue?vue&type=script&lang=js"
import style0 from "./conti-constani.vue?vue&type=style&index=0&id=50f35a4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f35a4d",
  null
  
)

export default component.exports